"use strict";

var _objectSpread = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _objectWithoutProperties = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _excluded = ["startFrom", "endAt"],
    _excluded2 = ["loop"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Video = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var get_environment_1 = require("../get-environment");

var loop_1 = require("../loop");

var Sequence_1 = require("../Sequence");

var use_video_config_1 = require("../use-video-config");

var validate_media_props_1 = require("../validate-media-props");

var validate_start_from_props_1 = require("../validate-start-from-props");

var duration_state_1 = require("./duration-state");

var VideoForDevelopment_1 = require("./VideoForDevelopment");

var VideoForRendering_1 = require("./VideoForRendering");

var VideoForwardingFunction = function VideoForwardingFunction(props, ref) {
  var startFrom = props.startFrom,
      endAt = props.endAt,
      otherProps = _objectWithoutProperties(props, _excluded);

  var loop = props.loop,
      propsOtherThanLoop = _objectWithoutProperties(props, _excluded2);

  var _ref = (0, use_video_config_1.useVideoConfig)(),
      fps = _ref.fps;

  var _ref2 = (0, react_1.useContext)(duration_state_1.DurationsContext),
      durations = _ref2.durations,
      setDurations = _ref2.setDurations;

  if (typeof ref === 'string') {
    throw new Error('string refs are not supported');
  }

  var onDuration = (0, react_1.useCallback)(function (src, durationInSeconds) {
    setDurations({
      type: 'got-duration',
      durationInSeconds: durationInSeconds,
      src: src
    });
  }, [setDurations]);

  if (loop && props.src && durations[props.src] !== undefined) {
    return (0, jsx_runtime_1.jsx)(loop_1.Loop, {
      durationInFrames: Math.round(durations[props.src] * fps),
      children: (0, jsx_runtime_1.jsx)(exports.Video, _objectSpread(_objectSpread({}, propsOtherThanLoop), {}, {
        ref: ref
      }))
    });
  }

  if (typeof startFrom !== 'undefined' || typeof endAt !== 'undefined') {
    (0, validate_start_from_props_1.validateStartFromProps)(startFrom, endAt);
    var startFromFrameNo = startFrom !== null && startFrom !== void 0 ? startFrom : 0;
    var endAtFrameNo = endAt !== null && endAt !== void 0 ? endAt : Infinity;
    return (0, jsx_runtime_1.jsx)(Sequence_1.Sequence, {
      layout: "none",
      from: 0 - startFromFrameNo,
      showInTimeline: false,
      durationInFrames: endAtFrameNo,
      children: (0, jsx_runtime_1.jsx)(exports.Video, _objectSpread(_objectSpread({}, otherProps), {}, {
        ref: ref
      }))
    });
  }

  (0, validate_media_props_1.validateMediaProps)(props, 'Video');

  if ((0, get_environment_1.getRemotionEnvironment)() === 'rendering') {
    return (0, jsx_runtime_1.jsx)(VideoForRendering_1.VideoForRendering, _objectSpread(_objectSpread({
      onDuration: onDuration
    }, otherProps), {}, {
      ref: ref
    }));
  }

  return (0, jsx_runtime_1.jsx)(VideoForDevelopment_1.VideoForDevelopment, _objectSpread(_objectSpread({
    onlyWarnForMediaSeekingError: false
  }, otherProps), {}, {
    ref: ref,
    onDuration: onDuration
  }));
};

exports.Video = (0, react_1.forwardRef)(VideoForwardingFunction);